import React, { useEffect, useState } from "react";
import { useBreakpoint } from "gatsby-plugin-breakpoints";

import InputFloatLabel from "components/Design/Input/InputFloatLabel";
import { InputDateRangeDropdown } from "components/DateRangeInput/InputDateRangeDropdown";
import { InputDateRangeDrawer } from "components/DateRangeInput/InputDateRangeDrawer";
import PrimaryButtonFullWidth from "components/Design/Button/PrimaryButtonFullWidth";
import RoomGuestSelectDrawer from "components/RoomGuestSelect/RoomGuestSelectDrawer";
import RoomGuestSelect from "components/RoomGuestSelect/RoomGuestSelect";
import { renderForMobile } from "utils/renderForMobile";
import ClearTextInput from "./Icons/ClearTextIcon";
import { checkBookingCodeRule } from "utils/bookingCodeValidation";
import { getCalendarRates } from "apis/calendarRates";
import { JAKARTA, JAKARTA_LOCATION } from "store/constants/hotel";
import { useTranslation } from "gatsby-plugin-react-i18next";

const BookingFormVertical = ({
  guest,
  destination,
  setDateValues,
  setGuestCount,
  onDateChange,
  buttonLabel,
  startDate,
  endDate,
  bookingCode,
  setBookingCode,
  destinationLabel,
  stayingDateLabel,
  bookingCodeLabel,
  bookingCodePlaceholder,
  location,
  hotelId,
  roomId,
}) => {
  const breakpoints = useBreakpoint();
  const { t } = useTranslation("homepage");

  const validateBookingCodeOnKeyPress = (e) => {
    if (checkBookingCodeRule(e)) {
      e.preventDefault();
      return false;
    }
  };

  const [dateRate, setDateRate] = useState(null);

  useEffect(() => {
    const getDateRatesLocation = async () => {
      const rates = await getCalendarRates({
        location_code: location,
      });

      setDateRate(rates);
    };

    const getDateRatesHotel = async () => {
      const rates = await getCalendarRates({
        hotel_code_id: hotelId,
        location_code: location,
      });

      setDateRate(rates);
    };

    const getDateRatesRoom = async () => {
      const rates = await getCalendarRates({
        room_type_id: roomId,
        location_code: location,
      });

      setDateRate(rates);
    };

    if (hotelId && !roomId) {
      getDateRatesHotel();
    } else if (roomId) {
      getDateRatesRoom();
    } else {
      getDateRatesLocation();
    }
  }, [location, hotelId, roomId]);

  return (
    <div className="grid grid-cols-2 space-y-16">
      {destination && (
        <div className="col-span-2 border border-gray-light shadow-input-booking">
          <InputFloatLabel
            label={destinationLabel}
            value={destination}
            className="h-full pointer-events-none"
            noBorder
            readOnly
          />
        </div>
      )}
      {renderForMobile(breakpoints) ? (
        <div className="w-full grid-cols-2 col-span-2 lg:col-span-2 shadow-input-booking lg:shadow-none">
          <InputDateRangeDrawer
            note={
              location === JAKARTA || location === JAKARTA_LOCATION
                ? undefined
                : t("price_note")
            }
            title={stayingDateLabel}
            drawerProps={{
              placement: "bottom",
              height: "100%",
            }}
            onSave={setDateValues}
            onChange={onDateChange}
            endDate={endDate}
            startDate={startDate}
            saveCta={(onClick) => (
              <div className="fixed bottom-0 w-full">
                <PrimaryButtonFullWidth label={buttonLabel} onClick={onClick} />
              </div>
            )}
            dateRate={dateRate}
            hotelId={hotelId}
          />
        </div>
      ) : (
        <div className="w-full grid-cols-2 col-span-2 shadow-input-booking">
          <InputDateRangeDropdown setDateValues={setDateValues} />
        </div>
      )}
      {renderForMobile(breakpoints) ? (
        <div className="col-span-2 border lg:border-0 border-gray-light lg:col-span-1 lg:my-0 shadow-input-booking lg:shadow-none">
          <RoomGuestSelectDrawer
            rooms={guest.rooms}
            adults={guest.adults}
            infants={guest.infants}
            children={guest.children}
            location={location}
            onSave={setGuestCount}
          />
        </div>
      ) : (
        <div className="col-span-2 border border-gray-light shadow-input-booking">
          <RoomGuestSelect
            rooms={guest.rooms}
            adults={guest.adults}
            infants={guest.infants}
            children={guest.children}
            setGuestCount={setGuestCount}
            location={location}
          />
        </div>
      )}
      <div className="col-span-2 border border-gray-light shadow-input-booking">
        <InputFloatLabel
          value={bookingCode}
          onChange={(e) => setBookingCode(e.target.value)}
          onKeyPress={validateBookingCodeOnKeyPress}
          label={bookingCodeLabel}
          placeholder={bookingCodePlaceholder}
          suffixIcon={
            bookingCode && (
              <ClearTextInput
                className="w-20 h-20 cursor-pointer z-2 text-gray-dark"
                onClick={() => setBookingCode("")}
              />
            )
          }
          className="h-full cursor-pointer"
          noBorder
          floatLabelByDefault
          uppercase
        />
      </div>
    </div>
  );
};

export default BookingFormVertical;
